import api from '@/utils/api';

/**
 * Resend register email
 * @param {string} id user id
 * @returns {Promise}
 */
const resendUserEmailApi = (id) => api.patch(`/user/${id}/resend-email`);

export default resendUserEmailApi;
